import React, {useContext, useState } from 'react';
import {useMsal} from '@azure/msal-react';
import {AccountInfo} from '@azure/msal-browser';
import {NavLink, useLocation} from 'react-router-dom';
import {getTopBarNavItems} from '../functions/getTopBarNavItems';
import {UserContext} from '../context/userContext';
import AdminSetting from './AdminSetting';
import WholesalerIcon from '../../../assests/img/wholesale-icon.svg?react';
import HomeLogo from './HomeLogo';
import '../../../assests/css/topbar.scss';
import UserProfile from './UserProfile';


export interface topBarProps{
    accountData: AccountInfo[]
}

export default function TopBar(props: topBarProps) {

    const [showMenu, setShowMenu]=useState(false);
    const {instance} = useMsal();
    const accountData = props.accountData[0];
    const {data} = useContext(UserContext);

    const currentLocation = useLocation();

    const handleSignOut=()=> {
        instance.logoutPopup();
    }

    const topBarNavItems = getTopBarNavItems(currentLocation.pathname);

    return (
        <>
        <div className="topbar-container">
            <div className="topbar-logo">
                <HomeLogo isLinkable={true}/>
            </div>
            <div className="topbar-controls-container ms-auto">
                <div className="topbar-controls">
                    {topBarNavItems
                        .map((navItem, index) => {
                        return (
                            <React.Fragment key={navItem.url}>
                                {navItem.separator && <span className='header-menu-separator'></span>}
                                <NavLink
                                    to={`${navItem.url}`}
                                    className={navItem.className}
                                    end={index===0}
                                    key={`${navItem.url}`}
                                    >
                                    <WholesalerIcon width={32} height={32}/>
                                </NavLink>
                            </React.Fragment>
                        );
                    })}
                </div>
            </div>
            <div onClick={()=> setShowMenu(!showMenu)} className="topbar-profile-container">
                <div
                    onClick={(e)=> e.stopPropagation()}
                    style={{width: '24px', height: '24px'}}
                    className='d-flex align-items-center justify-content-center'
                >
                    <AdminSetting isAdmin={data.permissions.includes('A')}/>
                </div>
                <UserProfile email={accountData?.username} accountName={accountData.name ? accountData.name : ''} signOut={handleSignOut}/>
            </div>
        </div>
        </>
    );


}